import { lazy } from 'react';
const PilowGradeTwo = lazy(() => import('./PilowGradeTwo'));

const PillowGreadeTwoRoutes = [
  {
    path: '/pillowgradetwo/:type',
    component: PilowGradeTwo
  }
];

export default PillowGreadeTwoRoutes;
